import LinkButton, { type Appearance } from '@atlaskit/button/new';
import { Pressable, type XCSS } from '@atlaskit/primitives';
import { type Options } from '@atlassiansox/cross-flow-support';
import { type ReactNode } from 'react';

import { useCrossflowMessageClicked } from './use-crossflow-message-clicked';
import { type JSX } from 'react/jsx-runtime';

export type BaseButtonProps = {
	crossflowOptions: Options;
	ctaText: ReactNode;
	alt?: string;
};

export type LinkButtonProps = BaseButtonProps & {
	appearance: Appearance;
};

export type PressableProps = BaseButtonProps & {
	pressableStyle: XCSS;
};

export const CrossflowCtaPrimaryLinkButton = ({
	crossflowOptions,
	ctaText,
	appearance,
	alt,
}: LinkButtonProps): JSX.Element => {
	const { handleClick } = useCrossflowMessageClicked(crossflowOptions, 'cta');

	return (
		<LinkButton onClick={handleClick} appearance={appearance} aria-label={alt}>
			{ctaText}
		</LinkButton>
	);
};

export const CrossflowCtaPrimaryPressable = ({
	crossflowOptions,
	ctaText,
	pressableStyle,
	alt,
}: PressableProps): JSX.Element => {
	const { handleClick } = useCrossflowMessageClicked(crossflowOptions, 'cta');

	return (
		<Pressable onClick={handleClick} xcss={pressableStyle} aria-label={alt}>
			{ctaText}
		</Pressable>
	);
};

export const CrossflowCtaSecondaryPressable = ({
	crossflowOptions,
	ctaText,
	pressableStyle,
	alt,
}: PressableProps): JSX.Element => {
	const { handleClick } = useCrossflowMessageClicked(crossflowOptions, 'cta');

	return (
		<Pressable onClick={handleClick} xcss={pressableStyle} aria-label={alt}>
			{ctaText}
		</Pressable>
	);
};
